import { OverlayTrigger, Popover } from 'react-bootstrap'
import { getCSSVariableValue } from '../_metronic/assets/ts/_utils'
import { hexToRGB } from './HexToRgba'

export function ShowTags(tags: string[]) {
  return (
    <>
      {tags &&
        tags.map((tag: string, index: number) => {
          return (
            <>
              <span
                key={index}
                className={`badge fs-9 fw-semibold mb-1 ms-2 `}
                style={{
                  background: hexToRGB(getCSSVariableValue('--kt-donut-' + (index % 10)), 0.2),
                  color: hexToRGB(getCSSVariableValue('--kt-donut-' + (index % 10)), 1),
                }}
              >
                {index < 2 && tag}
              </span>
              {index >= 2 && index === tags.length - 1 && (
                <OverlayTrigger
                  trigger={['hover', 'focus']}
                  placement='bottom'
                  rootCloseEvent='mousedown'
                  overlay={tagsPopover(tags)}
                >
                  <span
                    className={`badge fs-9 fw-semibold mb-1 ms-2 `}
                    style={{
                      background: hexToRGB(getCSSVariableValue('--kt-donut-' + (3 % 10)), 0.2),
                      color: hexToRGB(getCSSVariableValue('--kt-donut-' + (3 % 10)), 1),
                      cursor: 'pointer',
                    }}
                  >
                    {'+' + (tags.length - 2)}
                  </span>
                </OverlayTrigger>
              )}
            </>
          )
        })}
    </>
  )
}

const tagsPopover = (tags: string[]) => (
  <Popover id='popover-basic'>
    <Popover.Body>
      {tags.map((tag: string, index: number) => {
        return (
          <span
            className={`badge fs-9 fw-semibold mb-1 ms-2 text-wrap`}
            style={{
              background: hexToRGB(getCSSVariableValue('--kt-donut-' + (index % 10)), 0.2),
              color: hexToRGB(getCSSVariableValue('--kt-donut-' + (index % 10)), 1),
            }}
          >
            {index >= 2 && tag}
          </span>
        )
      })}
    </Popover.Body>
  </Popover>
)
export const DirectorPopover = (data: any) => (
  <Popover id='popover-basic '>
    <Popover.Body className='p-2 text-wrap'>
      {data?.map((director: any) => {
        return (
          <div className='fs-6 fw-semibold mb-2 mx-2 text-wrap text-gray-800'>{director?.name}</div>
        )
      })}
    </Popover.Body>
  </Popover>
)
